import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridSortModel } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import HttpService from "../../../../Hooks/Https-services";
import { APIRoutes, PageRoutes } from "../../../../Utils/constant";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";

// Dummy API functions (replace with real API calls)
async function purgeGame(gameId: string) {
  try {
    const res = await HttpService.post(APIRoutes.PurgeGame + `/${gameId}`, {});
    console.log("Purging game:", gameId);
  } catch (error) {
    toast.error("Failed to purge game");
    console.log(error);
  }
}
async function purgeCDN(gameId: string) {
  // TODO: Replace with actual API call
  try {
    const res = await HttpService.post(APIRoutes.PurgeCDN + `/${gameId}`, {});
    console.log("Purging CDN for game:", gameId);
  } catch (error) {
    toast.error("Failed to purge CDN");
    console.log(error);
  }
}

// Separate component for the action cell to properly use hooks
function ActionCell({
  data,
  handleRefresh,
}: {
  data: any;
  handleRefresh: () => void;
}) {
  const [openDialog, setOpenDialog] = useState<null | "game" | "cdn">(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleOpen = (type: "game" | "cdn") => setOpenDialog(type);
  const handleClose = () => setOpenDialog(null);

  const handleConfirm = async () => {
    if (openDialog === "game") {
      // Call purge game API here
      setIsLoading(true);
      await purgeGame(data.row.game_id);
      setIsLoading(false);
    } else if (openDialog === "cdn") {
      // Call purge CDN API here
      setIsLoading(true);
      await purgeCDN(data.row.game_id);
      setIsLoading(false);
    }
    handleClose();
    handleRefresh();
  };

  return (
    <>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="Purge Game" placement="top" arrow>
          <IconButton
            color="error"
            onClick={() => handleOpen("game")}
            size="small"
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Purge CDN" placement="top" arrow>
          <IconButton
            color="warning"
            onClick={() => handleOpen("cdn")}
            size="small"
          >
            <CloudOffIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Dialog open={!!openDialog} onClose={handleClose}>
        <DialogTitle>
          Confirm {openDialog === "game" ? "Purge Game" : "Purge CDN"}?
        </DialogTitle>
        <DialogContent>
          Are you sure you want to purge{" "}
          {openDialog === "game" ? "this game" : "the CDN for this game"}?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <LoadingButton
            loading={isLoading}
            onClick={handleConfirm}
            color="error"
            variant="contained"
          >
            Confirm
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default function GameListTable() {
  const [games, setGames] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 10,
    page: 0,
  });
  const [sortModel, setSortModel] = React.useState<GridSortModel>([]);
  const [_searchQuery, _setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(_searchQuery);
  const [totalPage, setTotalPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const navigate = useNavigate();
  const handleRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
  };
  const columns: GridColDef[] = [
    { field: "game_id", headerName: "Game Id", width: 90 },
    {
      field: "away_team",
      renderCell: (data: any) => {
        return <>{data?.row?.away_team?.team_name}</>;
      },
      headerName: "Away Team",
      width: 250,
      sortable: true,
    },
    {
      field: "home_team",
      headerName: "Home Team",
      width: 250,
      renderCell: (data: any) => {
        return <>{data?.row?.home_team?.team_name}</>;
      },
      editable: true,
    },
    {
      field: "video_status",
      headerName: "Video Status",
      width: 250,
      renderCell: (data: any) => {
        return <>{data?.row?.video_status}</>;
      },
      editable: true,
    },
    {
      field: "date",
      headerName: "Date",
      width: 110,
      sortable: false,
      filterable: false,
      hideable: false,
      editable: false,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 250,
      renderCell: (data: any) => {
        return (
          <>{moment(data?.row?.createdAt).format("YYYY-MM-DD hh:mm:ss a z")}</>
        );
      },
      editable: true,
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      width: 120,
      renderCell: (data: any) => (
        <ActionCell data={data} handleRefresh={handleRefresh} />
      ),
    },
  ];

  const GetGames = useCallback(async () => {
    console.log(isRefresh);
    const query: any = {
      page: paginationModel.page + 1,
      limit: paginationModel.pageSize,
      search: _searchQuery,
      ...(sortModel[0]?.field && {
        sortField: sortModel[0]?.field || "",
        sortOrder: sortModel[0]?.sort || "",
      }),
    };
    try {
      const res = await HttpService.get(
        APIRoutes.GetGamesAll + "?" + new URLSearchParams(query).toString()
      );
      setGames(res.data.data);
      setTotalPage(res.data.pagination?.totalRecords);
    } catch (error) {}
  }, [
    paginationModel.page,
    paginationModel.pageSize,
    _searchQuery,
    sortModel,
    isRefresh,
  ]);
  useEffect(() => {
    GetGames();
  }, [GetGames]);
  const handleSearchValueChange = (e: any) => {
    setDebouncedQuery(e.target.value);
  };
  useEffect(() => {
    const timer = setTimeout(() => _setSearchQuery(debouncedQuery), 1000);
    return () => clearTimeout(timer);
  }, [debouncedQuery]);
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TextField
          size="small"
          label="Search"
          onChange={handleSearchValueChange}
          name="searchQuery"
          value={debouncedQuery}
          sx={{
            my: 1,
          }}
        />
        <Button
          size="small"
          variant="contained"
          onClick={() => navigate(PageRoutes.NLPSeach)}
        >
          Try NLP Search
        </Button>
      </Box>

      <DataGrid
        rows={games}
        pagination
        rowCount={totalPage}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        sortingMode="server"
        onSortModelChange={handleSortModelChange} // Handle sort change
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        disableColumnSelector
        disableDensitySelector
        disableColumnFilter
        disableColumnMenu
        disableColumnResize
        sx={{
          borderRadius: "8px",
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
          },
          ".MuiDataGrid-cellContent": {
            pointerEvents: "none",
          },
          ".MuiDataGrid-cell--textLeft": {
            alignItems: "center !important",
            display: "flex",
          },
        }}
        onCellClick={(data) => {
          if (data.field === "action") {
            return;
          }
          navigate(PageRoutes.Game.replace(":id", data.row.game_id));
        }}
        paginationMode="server" // Enable server-side pagination
      />
    </Box>
  );
}
